import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import './../../ui.style.scss'
import UsersEmailInput from '../inputs/UsersEmailInput'

class AddDeactiveUserModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ip: []
    }
  }

  onChangeIp = (value) => {
    this.setState({ ip: value, isSaveEnabled: true })
  }

  render () {
    const { visible, handleCancel, title, okText, selectedUser, handleChange, updatedList, isLoading } = this.props
    const isDisabled = !updatedList
    return (

      <Modal
        className='general-modal add-user-modal'
        visible={visible}
        closable={false}
        title={title}
        okButtonProps={{ disabled: isDisabled, loading: isLoading }}
        onOk={this.props.handleSubmit}
        onCancel={handleCancel}
        okText={okText}
        cancelText='Cancel'
        afterClose={this.resetState}
        width='890px'
        centered
        destroyOnClose
        maskClosable={false}
        confirmLoading={isLoading}
      >
        <div className='user-ip' style={{ marginTop: 0 }} >
          <label className='user-groups'> Users </label>
          <UsersEmailInput
            containerClass='tags'
            title='Default Values'
            placeholder={'Enter User Name'}
            inputName='defaultValues'
            value={selectedUser || []}
            handleChange={handleChange}
            readOnly
          />
        </div>
      </Modal>
    )
  }
}

AddDeactiveUserModal.propTypes = {
  /** visible action of AddDeactiveUserModal. */
  visible: PropTypes.bool,
  /** title  of AddDeactiveUserModal. */
  title: PropTypes.string,
  /** handleCancel action of AddDeactiveUserModal. */
  handleCancel: PropTypes.func,
  /** List of user groups */
  groupList: PropTypes.array,
  /** Name of the user for edit */
  userName: PropTypes.string,
  /** ID of the user for edit */
  userId: PropTypes.string,
  /** Selected userGroups */
  userGroups: PropTypes.any,
  /** Boolean to indicates from edit or create */
  isFromEdit: PropTypes.bool,
  /** Boolean to disable submit button */
  isSubmitDisabled: PropTypes.bool
}

export default AddDeactiveUserModal
